// Static clinic information (source of truth for public UI defaults).
export const CLINIC = {
  doctorName: "Dr. Mithee Bhanot",
  qualifications: "M.B.B.S, D.G.O, D.N.B, MRCOG (London)",
  qualificationList: ["M.B.B.S", "D.G.O", "D.N.B", "MRCOG (London)"],
  title: "Senior Consultant Obstetrician & Gynaecologist",
  experience: "25+ Years of Experience",
  clinicName: "Dr. Mithee's Clinic for Women",
  tagline: "Nurturing Life",
  address: "Shop No. 41A, Vibe Mall, Sector-110, Noida, India",
  doctorMobile: "+91-9811552260",
  appointmentMobile: "+91-9811331362",
  email: "Mithee.bhanot@gmail.com",
  whatsapp: "919811331362",
};

export const ASSETS = {
  logo: "/brand/logo.png",
  logoSign: "/brand/logo-sign.png",
  doctorSaree: "/brand/doctor-saree.png",
  doctorCoat: "/brand/doctor-coat.png",
  clinicInterior:
    "https://images.unsplash.com/photo-1758448093806-88b2089068ab?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwyfHxwcmVtaXVtJTIwbHV4dXJ5JTIwbWVkaWNhbCUyMGNsaW5pYyUyMGludGVyaW9yJTIwd2FybSUyMGxpZ2h0aW5nfGVufDB8fHx8MTc4NjY3OTk4M3ww&ixlib=rb-4.1.0&q=85",
  waitingRoom:
    "https://images.unsplash.com/photo-1759262151080-e05ba1c6294f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwzfHxwcmVtaXVtJTIwbHV4dXJ5JTIwbWVkaWNhbCUyMGNsaW5pYyUyMGludGVyaW9yJTIwd2FybSUyMGxpZ2h0aW5nfGVufDB8fHx8MTc4NjY3OTk4M3ww&ixlib=rb-4.1.0&q=85",
  maternity:
    "https://images.unsplash.com/photo-1615766553246-9147b6d50e90?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHw0fHxlbGVnYW50JTIwbWF0ZXJuaXR5JTIwcHJlZ25hbmN5JTIwY2FyZSUyMHdvbWFufGVufDB8fHx8MTc4NjY3OTk4M3ww&ixlib=rb-4.1.0&q=85",
  botanical:
    "https://images.unsplash.com/photo-1597573189474-4fcb08837016?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHw0fHxtaW5pbWFsJTIwYWJzdHJhY3QlMjBib3RhbmljYWwlMjBsZWFmJTIwbGluZSUyMGFydCUyMG5hdHVyZXxlbnwwfHx8fDE3ODY2Nzk5ODN8MA&ixlib=rb-4.1.0&q=85",
};

export const TIMINGS = [
  { day: "Monday – Friday", time: "12:30 PM – 2:00 PM", note: "Morning consultation" },
  { day: "Mon, Wed, Fri", time: "5:30 PM – 7:30 PM", note: "Evening consultation" },
  { day: "Tuesday, Thursday", time: "6:30 PM – 7:30 PM", note: "Evening consultation" },
  { day: "Saturday", time: "11:00 AM – 2:00 PM", note: "" },
  { day: "Sunday", time: "11:00 AM – 1:00 PM", note: "" },
];

export const STAGES = [
  { title: "Adolescence", desc: "Gentle guidance on menstrual health, puberty and early wellbeing." },
  { title: "Reproductive Years", desc: "Contraception, cycle concerns and reproductive health." },
  { title: "Pregnancy", desc: "Antenatal care and personalised monitoring for a healthy journey." },
  { title: "Motherhood", desc: "Postpartum recovery and supportive care after birth." },
  { title: "Perimenopause", desc: "Understanding change with clarity and comfort." },
  { title: "Menopause", desc: "Compassionate midlife health and symptom guidance." },
  { title: "Beyond", desc: "Continued preventive care and long-term wellbeing." },
];

export const WHY_CHOOSE = [
  { title: "Experience", desc: "25+ years dedicated entirely to women's healthcare.", icon: "Award" },
  { title: "Personalised Attention", desc: "Care that considers each patient's individual needs and concerns.", icon: "UserRound" },
  { title: "Compassionate Approach", desc: "A calm, respectful and supportive environment.", icon: "HeartHandshake" },
  { title: "Specialist Expertise", desc: "Qualified obstetric and gynaecological care.", icon: "Stethoscope" },
  { title: "Patient-Centred Communication", desc: "Clear explanations and informed decision-making.", icon: "MessagesSquare" },
  { title: "Convenient Consultation", desc: "Easy appointment requests and direct clinic contact.", icon: "CalendarCheck" },
];

export const CREDENTIALS = [
  { big: "25+", small: "Years of Experience" },
  { big: "MRCOG", small: "London" },
  { big: "Senior Consultant", small: "Obstetrician & Gynaecologist" },
  { big: "Personalised", small: "Women's Healthcare" },
];

export const EMERGENCY_NOTICE =
  "For medical emergencies, please contact your local emergency services or visit the nearest emergency department. The website contact form is not monitored as an emergency service.";

export const CONSULTATION_TYPES = [
  "General Gynaecology Consultation",
  "Pregnancy / Antenatal Care",
  "Menstrual & Hormonal Concerns",
  "Preventive Health Check",
  "Menopause & Midlife Health",
  "Follow-up Consultation",
  "Other",
];

export function tel(num) {
  return "tel:" + num.replace(/[^+0-9]/g, "");
}
export function mailto(email) {
  return "mailto:" + email.trim();
}
